import React from 'react';
import {useNavigate} from "react-router-dom";
import notify from "devextreme/ui/notify";
import UsersServices, {RegisterResponse} from "../../services/UsersServices";
import {FormHelperText, Form, Button, ActionGroup} from "@patternfly/react-core";
import {ExclamationCircleIcon} from "@patternfly/react-icons";
import {useAuthState} from "../../Context/AuthProvider/AuthProvider";
import {DiazarFormInput} from "../Form/DiazarFormInput";


export const RegisterForm = () => {
    const [name, setName] = React.useState<string>('');
    const [isValidName, setIsValidName] = React.useState<boolean>(false);
    const [lastname, setLastName] = React.useState<string>('');
    const [isValidLastName, setIsValidLastName] = React.useState<boolean>(false);
    const [email, setEmail] = React.useState<string>('');
    const [isValidEmail, setIsValidEmail] = React.useState<boolean>(false);
    const [password, setPassword] = React.useState<string>('');
    const [isValidPassword, setIsValidPassword] = React.useState<boolean>(false);
    const [cpassword, setCPassword] = React.useState<string>('');
    const [isValidCPassword, setIsValidCPassword] = React.useState<boolean>(false);
    const [userOnValidation, setUserOnValidation] = React.useState<boolean>(false);
    const { loading, errorMessage } = useAuthState();

    const navigate = useNavigate();

    /*const passwordComparison = React.useCallback<any>(() => password, [password]);*/

    const register = async () => {
        const response: RegisterResponse = await UsersServices.register(password, email, name, lastname);

        if (response.status === "SUCCESS" ) {
            setUserOnValidation(true);
            notify({
                    message: '¡Excelente!, solo un paso más',
                    type: "success",
                    displayTime: 5000,
                    animation: {
                        show: {
                            type: 'fade', duration: 400, from: 0, to: 1,
                        },
                        hide: { type: 'fade', duration: 40, to: 0 },
                    },
                } ,
                {
                    position : "top right",
                    direction: "down-push"
                })
            notify({
                    message: 'Por favor revisar tu correo electrónico y sigue la instrucciones.',
                    type: "success",
                    displayTime: 5000,
                    animation: {
                        show: {
                            type: 'fade', duration: 400, from: 0, to: 1,
                        },
                        hide: { type: 'fade', duration: 40, to: 0 },
                    },
                } ,
                {
                    position : "top right",
                    direction: "down-push"
                })
            navigate('/login')
        } else {
            let message = response.error.error;
            if (response.error.error === "El usuario ya se encuentra registrado en el sistema") {
                message = "Correo electrónico ya registrado"
            }
            notify({
                    message: message,
                    type: "error",
                    displayTime: 5000,
                    animation: {
                        show: {
                            type: 'fade', duration: 400, from: 0, to: 1,
                        },
                        hide: { type: 'fade', duration: 40, to: 0 },
                    },
                } ,
                {
                    position : "top right",
                    direction: "down-push"
                })
        }
    }

    const isValidForm = React.useMemo<boolean>( () => {
        const isLoading = ( loading !== undefined ) ? loading : false
        return !isLoading && isValidName && isValidPassword && isValidLastName && isValidEmail && isValidCPassword

    }, [ isValidName, isValidPassword, loading, isValidLastName, isValidEmail, isValidCPassword] )

    const helperText = React.useMemo( () => {
        if ( errorMessage === undefined ){
            return null
        }else{
            return (
                <FormHelperText  >
                    <ExclamationCircleIcon />
                    &nbsp;{errorMessage}.
                </FormHelperText>
            )
        }
    }, [errorMessage] )

    return (
        <div className="auth-wrapper">
            <div className="auth-inner">
                {userOnValidation ?
                    <h3>Por favor revisar tu correo electrónico y sigue la instrucciones.</h3> :
                    <Form>
                        {helperText}
                        <DiazarFormInput id="name" label="Nombre" isRequired
                                         type="text"
                                         placeholder="Ingresa tu nombre"
                                         min={4}
                                         getState={ (isValid, value) => {
                                             setIsValidName(isValid)
                                             setName(value)
                                         } }
                        />
                        <DiazarFormInput id="lastname" label="Apellido" isRequired
                                         type="text"
                                         placeholder="Ingresa tu apellido"
                                         min={2}
                                         getState={ (isValid, value) => {
                                             setIsValidLastName(isValid)
                                             setLastName(value)
                                         } }
                        />
                        <DiazarFormInput id="email" label="Correo Electrónico" isRequired
                                         type="email"
                                         placeholder="Ingresa tu correo electrónico"
                                         getState={ (isValid, value) => {
                                             setIsValidEmail(isValid)
                                             setEmail(value)
                                         } }
                        />
                        <DiazarFormInput id="password" label="Contraseña" isRequired
                                         type="password"
                                         placeholder="Crea tu contraseña"
                                         register={true}
                                         min={8}
                                         getState={ (isValid, value) => {
                                             setIsValidPassword(isValid)
                                             setPassword(value)
                                         } }
                        />
                        <DiazarFormInput id="confirm-password" label="Confirma tu contraseña" isRequired
                                         type="password"
                                         placeholder="Confirma tu contraseña"
                                         register={true}
                                         min={8}
                                         isEqualTo={password}
                                         getState={ (isValid, value) => {
                                             setIsValidCPassword(isValid)
                                             setCPassword(value)
                                         } }
                        />
                        <ActionGroup>
                            <Button type="submit"
                                    onClick={ e => { e.preventDefault(); register() }}
                                    isBlock
                                    isDisabled={ !isValidForm }
                                    isLoading={ ( loading !== undefined ) ? loading : false }
                            >
                                Regístrarme
                            </Button>
                            <div style={{width: '100%', textAlign:'center', marginBottom: '15px'}}>
                                <span style={{backgroundColor:'white', padding:'0 15px'}}>Si ya tienes usuario</span>
                                <hr style={{marginTop:'-10px'}}/>
                            </div>
                            <Button type="submit"
                                    onClick={ e => { e.preventDefault(); navigate("/login") }}
                                    isBlock
                                    variant="secondary"
                            >
                                Inicia sesión
                            </Button>
                        </ActionGroup>
                    </Form>
                }
            </div>
        </div>
    );
}